import { Select, Input, Chip, MenuItem, withStyles, WithTheme, withTheme, Avatar } from "@material-ui/core";
import { IAuthContextProps } from "components/with-auth-context";
import { styles } from "material-ui-pickers/wrappers/InlineWrapper";
import { TagRequestFactory } from "model/autogen/TagController";
import { TagModel } from "model/autogen/TagModel";
import * as React from "react";
import { WithDefaultStyles } from "utils/createStyles";
import Label from "@material-ui/icons/Label";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name: string, that: ResourceTagListEditorComponent) {
    return {
        fontWeight:
            that.state.selected.indexOf(name) === -1
                ? that.props.theme.typography.fontWeightRegular
                : that.props.theme.typography.fontWeightMedium,
    };
}

type BaseResourceTagListEditorComponentProps = IAuthContextProps & {
    initialSelection: string[];
    onTagsChanged: (tags: TagModel[]) => void;
};

type ResourceTagListEditorComponentProps = WithDefaultStyles & WithTheme & BaseResourceTagListEditorComponentProps;

type ResourceTagListEditorState = {
    allTags: TagModel[] | undefined;
    selected: string[];
}

class ResourceTagListEditorComponent extends React.Component<ResourceTagListEditorComponentProps, ResourceTagListEditorState> {
    constructor(props: ResourceTagListEditorComponentProps) {
        super(props);
        this.state = {
            allTags: undefined,
            selected: this.props.initialSelection
        }
    }
    private onChange = (e: any) => {
        const selected = e.target.value;
        this.setState({ selected: selected }, () => {
            if (this.state.allTags) {
                const tags = [] as TagModel[];
                for (const tn of selected) {
                    const mt = this.state.allTags.find(t => t.name == tn);
                    if (mt) {
                        tags.push({ ...mt });
                    }
                }
                this.props.onTagsChanged(tags);
            }
        });
    };
    async componentDidMount() {
        const tags = await this.props.callApi((fetcher => TagRequestFactory.list(fetcher, true)));
        this.setState({
            allTags: tags
        });
    }
    render() {
        const { allTags, selected } = this.state;
        const classes: any = this.props.classes;
        if (!allTags)
            return <></>;

        return <Select
            multiple
            value={selected}
            onChange={this.onChange}
            input={<Input id="select-multiple-chip" />}
            renderValue={selected => (
                <div className={classes.chips}>
                    {Array.isArray(selected) && selected.map(value => (
                        <Chip key={`${value}`} avatar={<Avatar><Label /></Avatar>} label={value} className={classes.chip} />
                    ))}
                </div>
            )}
            MenuProps={MenuProps}
        >
            {allTags.map(tag => (
                <MenuItem key={tag.id} value={tag.name} style={getStyles(tag.name, this)}>
                    {tag.name}
                </MenuItem>
            ))}
        </Select>
    }
}

export const ResourceTagListEditor = withTheme()(withStyles(styles as any)(ResourceTagListEditorComponent)) as React.ComponentType<BaseResourceTagListEditorComponentProps>;


// WEBPACK FOOTER //
// ./src/components/material/resource-tag-list-editor.tsx